import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('TODOS');
  const filters = ['TODOS', 'RESTAURANTE', 'BARBERÍA', 'CLÍNICA'];
  const projects = [{
    id: 1,
    category: 'RESTAURANTE',
    icon: '🍕',
    title: 'Demo Restaurante',
    type: 'Sitio Web para Negocio / Web Plus según necesidad',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    features: ['Diseño profesional', 'Menú y galería de platos', 'Mapa y horarios', 'Reservas por WhatsApp', 'Adaptado a celular'],
    note: '¿Necesitas tienda online o catálogo digital? Lo adaptamos a tu medida.'
  }, {
    id: 2,
    category: 'BARBERÍA',
    icon: '✂️',
    title: 'Demo Barbería',
    type: 'Landing Page / Sitio Web según necesidad',
    image: 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    features: ['Diseño moderno y atractivo', 'Servicios y precios', 'Botón para agendar por WhatsApp', 'Galería de cortes', 'Adaptado a celular'],
    note: '¿Necesitas algo más completo? Lo adaptamos a tu medida.'
  }, {
    id: 3,
    category: 'CLÍNICA',
    icon: '🦷',
    title: 'Demo Clínica Odontológica',
    type: 'Sitio Web para Negocio / Web Plus según necesidad',
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    features: ['Diseño profesional y confiable', 'Servicios odontológicos', 'Galería del consultorio', 'Formulario de cita', 'Mapa de ubicación', 'Adaptado a celular'],
    note: '¿Necesitas catálogo de tratamientos o tienda online? Lo adaptamos a tu medida.'
  }];
  const filteredProjects = activeFilter === 'TODOS' ? projects : projects.filter(p => p.category === activeFilter);
  return <section id="portafolio" className="py-32 bg-nova-bg-alt relative" data-id="element-246">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-247">
        <img src="https://cdn.magicpatterns.com/uploads/cXQ7JNAVDPENfU9BD6teEL/heylloyd-image-1780234013952.png" alt="Abstract Tech Background" className="w-full h-full object-cover opacity-5 mix-blend-screen" data-id="element-248" />
        <div className="absolute inset-0 bg-gradient-to-b from-nova-bg-alt via-transparent to-nova-bg-alt" data-id="element-249" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-252">
            Mira Lo Que Hemos Creado
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4 mb-4" data-id="element-253" />
          <p className="text-lg text-nova-text-muted max-w-2xl mx-auto" data-id="element-254">
            Cada página que diseñamos tiene un objetivo claro: conseguirle más
            clientes al negocio.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-255">
          {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${activeFilter === filter ? 'bg-nova-accent text-nova-bg' : 'bg-nova-card text-nova-text-muted hover:text-nova-text'}`} data-id="element-256">
              {filter}
            </button>)}
        </div>

        <motion.div layout className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-16 items-stretch" data-id="element-257">
          <AnimatePresence data-id="element-258">
            {filteredProjects.map(project => <motion.div key={project.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} className="bg-nova-card rounded-2xl overflow-hidden border border-nova-bg-alt flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(0,212,255,0.15)]" data-id="element-259">
                <div className="h-48 overflow-hidden relative group" data-id="element-260">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-261" />
                  <div className="absolute inset-0 bg-nova-bg/40 group-hover:bg-transparent transition-colors duration-300" data-id="element-262" />
                </div>

                <div className="p-6 flex-grow flex flex-col" data-id="element-263">
                  <div className="flex items-center gap-2 mb-2" data-id="element-264">
                    <span className="text-2xl" data-id="element-265">{project.icon}</span>
                    <h3 className="text-xl font-bold text-nova-text" data-id="element-266">
                      {project.title}
                    </h3>
                  </div>
                  <p className="text-xs text-nova-accent mb-6" data-id="element-267">
                    {project.type}
                  </p>

                  <ul className="space-y-2 mb-6 flex-grow" data-id="element-268">
                    {project.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-269">
                        <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={16} data-id="element-270" />
                        <span className="text-sm text-nova-text-muted" data-id="element-271">
                          {feature}
                        </span>
                      </li>)}
                  </ul>

                  <div className="bg-nova-bg-alt p-3 rounded-lg mb-6" data-id="element-272">
                    <p className="text-xs text-nova-text-muted italic" data-id="element-273">
                      {project.note}
                    </p>
                  </div>

                  <div className="flex flex-col gap-3 mt-auto" data-id="element-274">
                    <button className="w-full text-center px-10 py-4 rounded-full font-bold bg-transparent border-2 border-[#00D4FF] text-white hover:bg-[#00D4FF]/10 transition-all duration-300 text-sm" data-id="element-275">
                      VER DEMO EN VIVO
                    </button>
                    <a href={`https://wa.me/573508108717?text=Hola,%20me%20gustaría%20algo%20como%20la%20${project.title}`} target="_blank" rel="noopener noreferrer" className="w-full text-center px-10 py-4 rounded-full font-bold bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105 transition-all duration-300 text-sm" data-id="element-276">
                      QUIERO ALGO ASÍ PARA MÍ
                    </a>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-nova-card p-8 rounded-2xl border border-nova-bg-alt max-w-2xl mx-auto" data-id="element-277">
          <h3 className="text-2xl font-bold text-nova-text mb-2" data-id="element-278">
            ¿Tu negocio no aparece aquí?
          </h3>
          <p className="text-nova-text-muted mb-6" data-id="element-279">
            No importa. Podemos crear algo personalizado para ti.
          </p>
          <a href="#contacto" className="inline-block text-center px-10 py-4 rounded-full font-bold bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105 transition-all duration-300" data-id="element-280">
            QUIERO MI PÁGINA PERSONALIZADA
          </a>
          <p className="mt-4 text-sm text-nova-text-muted" data-id="element-281"></p>
        </motion.div>
      </div>
    </section>;
}